<template>
    <div>
        <MulReportHeader :dataFrom="table.params" @search="searchData" ref="marketDataRef" :loading="loading" :toPdf="toPdf"></MulReportHeader>
        <Table border :columns="table.columns" :data="table.data" ref="tableRef" :max-height="maxHeight"></Table>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
export default {
    name: 'MarketData',
    components: { MulReportHeader },
    data() {
        return {
            maxHeight: 700,
            loading: false,
            TransTopReqTimer: null,
            table: {
                params: {
                    dataTime: this.getCurrentZeroDay(),
                    platids: [],
                    app_ids: []
                },
                data: [],
                columns: [
                    { type: 'index', title: '序号', align: 'center', width: 60 },
                    {
                        key: 'app_name',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '盘口', '显示对应的盘口名称')
                    },
                    {
                        key: 'new_user_num',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '新增人数', '显示该盘口的新增人数')
                    },
                    {
                        key: 'pay_user_num',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入人数', '筛选时间内,盘口转入人数；人数去重')
                    },
                    {
                        key: 'pay_sum',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => h('span', this.getCustomFixed(params.row.pay_sum / 10000)),
                        renderHeader: (h) => this.renderHeader(h, '转入金额', '显示该盘口的转入金额')
                    },
                    {
                        key: 'pay_ave',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => {
                            return h('span', this.getCustomFixed(params.row.pay_ave / 10000))
                        },
                        renderHeader: (h) => this.renderHeader(h, 'ARPPU', '统计盘口筛选时间内的【转入金额】/【转入人数】')
                    },
                    {
                        key: 'new_win_rate',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => {
                            let str = params.row.new_win_rate ? (params.row.new_win_rate == -1 ? '_' : (params.row.new_win_rate * 100).toFixed(2) + '%') : '0.00%'
                            return h('span', str)
                        },
                        renderHeader: (h) => this.renderHeader(h, '营收比', '统计盘口(【今日转入】-【今日转出】+【昨日余额】-【今日余额】) /【转入金额】')
                    },
                    {
                        key: 'pay_winner_rate',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => {
                            let str = params.row.pay_winner_rate ? (params.row.pay_winner_rate == -1 ? '_' : (params.row.pay_winner_rate * 100).toFixed(2) + '%') : '0.00%'
                            return h('span', str)
                        },
                        renderHeader: (h) => this.renderHeader(h, '转入赢家数占比', '【转入玩家赢的人数】/ (【转入玩家赢的人数】+【转入玩家输的人数】);不统计高倍游戏')
                    },
                    {
                        key: 'ci_ri_login_rate',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => h('span', this.calcRateItem(params.row.ci_ri_login_rate)),
                        renderHeader: (h) => this.renderHeader(h, '次日转入留存', '当天首充玩家，在第2天登录的人数/首充人数')
                    },
                    {
                        key: 'seven_login_rate',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => h('span', this.calcRateItem(params.row.seven_login_rate)),
                        renderHeader: (h) => this.renderHeader(h, '七日转入留存', '当天首充玩家，在第7天登录的人数/首充人数')
                    },
                    {
                        key: 'new_ci_ri_pay_rate',
                        width: 112,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => h('span', this.calcRateItem(params.row.new_ci_ri_pay_rate)),
                        renderHeader: (h) => this.renderHeader(h, '新增转入次日复充', '显示该盘口的新增转入次日复充')
                    },
                    {
                        key: 'new_seven_pay_rate',
                        width: 112,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => h('span', this.calcRateItem(params.row.new_seven_pay_rate)),
                        renderHeader: (h) => this.renderHeader(h, '新增转入七日复充', '显示该盘口的新增转入七日复充')
                    },
                    {
                        key: 'ci_ri_pay_rate',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => h('span', this.calcRateItem(params.row.ci_ri_pay_rate)),
                        renderHeader: (h) => this.renderHeader(h, '次日转入复充', '次日复充人数/转入人数')
                    },
                    {
                        key: 'seven_pay_rate',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => h('span', this.calcRateItem(params.row.seven_pay_rate)),
                        renderHeader: (h) => this.renderHeader(h, '七日转入复充', '七日复充人数/转入人数')
                    },
                    {
                        key: 'zhuan_rate',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => h('span', (params.row.zhuan_rate * 100 || 0).toFixed(2) + '%'),
                        renderHeader: (h) => this.renderHeader(h, '新增转化率', '当天新增且转入用户/当天新增人数')
                    },
                    {
                        key: 'count',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => {
                            let str = '0.00%'
                            let { give_sum, send_total_percent_sum, pay_sum } = params.row
                            if (give_sum != null && send_total_percent_sum != null && pay_sum) {
                                let total = give_sum + send_total_percent_sum
                                if (total) {
                                    str = ((total / pay_sum) * 100).toFixed(2) + '%'
                                }
                            }
                            return h('span', str)
                        },
                        renderHeader: (h) => this.renderHeader(h, '佣金赠送转入比', '（赠送+佣金）/转入')
                    },
                    {
                        key: 'bet_pay_rate',
                        width: 104,
                        resizable: true,
                        align: 'center',
                        render: (h, params) => {
                            let str = params.row.bet_pay_rate ? (params.row.bet_pay_rate == -1 ? '_' : params.row.bet_pay_rate.toFixed(2)) : '0'
                            return h('span', str)
                        },
                        renderHeader: (h) => this.renderHeader(h, '投注转入比', '统计盘口筛选时间内(【投注金额】/【转入金额】)')
                    },
                    {
                        key: 'pay_bet_user_num',
                        minWidth: 100,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入投注人数', '历史转入注册用户中，筛选时间内，筛选的子游戏中的投注人数')
                    }
                ]
            }
        }
    },
    methods: {
        //查询数据
        searchData(emitProps) {
            let paramsList = this.getAllHttpAppid(this.table.params)
            let httpList = []
            let callList = []

            for (let i = 0, len = paramsList.length; i < len; i++) {
                let app_id = paramsList[i]
                let app_name = ''
                let platid = 0
                let item = emitProps.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                }
                let stime = this.getSecond(this.table.params.dataTime)
                let etime = this.getSecond(this.table.params.dataTime, false)
                let param = this.getTransTopParams('GetNewPlatfromData', { platid, app_id, app_name, stime, etime, general: -1, pack_no: -1, page: 1, limit: 10000, sort: 0 })
                callList.push(1)
                httpList.push(param)
            }
            this.table.data = []
            this.openTimer()
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, callList)
            }
        },
        paramToYesterday(params) {
            params.param._param.stime = parseInt((params.param._param.stime - 24 * 60 * 60).toFixed(0))
            params.param._param.etime = parseInt((params.param._param.etime - 24 * 60 * 60).toFixed(0))
        },
        yesterDayToSevenDay(params) {
            params.param._param.stime = parseInt((params.param._param.stime - 5 * 24 * 60 * 60).toFixed(0))
            params.param._param.etime = parseInt((params.param._param.etime - 5 * 24 * 60 * 60).toFixed(0))
        },
        async toHttp(httpList, callList) {
            if (httpList.length > 0) {
                let param = httpList.shift()
                TransTopReq(param)
                    .then((res) => {
                        if (res._param && res._param.data) {
                            let data = res._param.data[0]
                            data.app_id = param.app_id
                            data.app_name = param.app_name
                            this.table.data.push(data)
                            let param1 = this.copyData(param)
                            param1.param._func = 'GetNewPlatformRepeatPayInfo'
                            this.paramToYesterday(param1)
                            let param3 = this.copyData(param1)
                            this.yesterDayToSevenDay(param3)
                            TransTopReq(param1).then((res1) => {
                                let from = res1._param.data[0]
                                let { ci_ri_pay_rate, ci_ri_login_rate } = from
                                let find = this.table.data.find((el) => el.app_id == data.app_id)
                                Object.assign(find, { ci_ri_pay_rate, ci_ri_login_rate })
                                this.table.data = this.copyData(this.table.data)
                            })
                            TransTopReq(param3).then((res3) => {
                                let from = res3._param.data[0]
                                let { seven_login_rate, seven_pay_rate } = from
                                let find = this.table.data.find((el) => el.app_id == data.app_id)
                                Object.assign(find, { seven_login_rate, seven_pay_rate })
                                this.table.data = this.copyData(this.table.data)
                            })
                            let param2 = this.copyData(param)
                            param2.param._func = 'GetNewPlatfromNewPayInfo'
                            this.paramToYesterday(param2)
                            let param4 = this.copyData(param2)
                            this.yesterDayToSevenDay(param4)
                            TransTopReq(param2).then((res2) => {
                                let find = this.table.data.find((el) => el.app_id == data.app_id)
                                Object.assign(find, { new_ci_ri_pay_rate: res2._param.data[0].ci_ri_pay_rate })
                                this.table.data = this.copyData(this.table.data)
                            })
                            TransTopReq(param4).then((res4) => {
                                let find = this.table.data.find((el) => el.app_id == data.app_id)
                                Object.assign(find, { new_seven_pay_rate: res4._param.data[0].seven_pay_rate })
                                this.table.data = this.copyData(this.table.data)
                            })
                        }
                        this.httpCallBack(callList)
                        this.toHttp(httpList, callList)
                    })
                    .catch((err) => {
                        this.httpCallBack(callList)
                        this.toHttp(httpList, callList)
                    })
            }
        },
        httpCallBack(callBackList) {
            callBackList.shift()
            if (callBackList.length == 0) {
                this.closeTimer()
            }
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                app_name: param.app_name,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        },

        toPdf() {
            this.maxHeight = null
            this.$nextTick(async () => {
                await this.eleToPdf()
                this.maxHeight = 700
            })
        },

        calcRateItem(val) {
            return val ? (val * 100).toFixed(2) + '%' : '0.00%'
        },
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 8000)
        }
    }
}
</script>

<style scoped lang="less"></style>
